import { createFileRoute } from '@tanstack/react-router'

import { PlatformActivityScreen } from './-components/platform-activity-screen.tsx'

export const Route = createFileRoute('/business-performance/platform-activity')(
  {
    component: PlatformActivityScreen
  }
)
